// This import loads the firebase namespace along with all its type information.
import Season from './season-model'

export async function load_seasons(): Promise<Season[]> {
  throw 'Not implemented'
}

export async function delete_season(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_season(): Promise<Season> {
  throw 'Not implemented'
}
